export default __webpack_public_path__ + "static/media/scb.104f44d8.svg";